'use client'

import { motion } from 'framer-motion'
import { Space_Grotesk } from 'next/font/google'
import { BackgroundBeams } from '@/app/_components/_ui/background-beams'

const spaceGrotesk = Space_Grotesk({
    subsets: ['latin'],
    variable: '--font-space-grotesk',
    display: 'swap',
})

export default function Templates() {
    return (
        <div className="min-h-screen w-full relative">
            <BackgroundBeams />
            <div className="container mx-auto px-4 py-24 relative z-10">
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="max-w-3xl mx-auto text-center"
                >
                    <h1 className={`${spaceGrotesk.className} text-4xl font-bold text-white mb-4`}>
                        Templates Coming Soon
                    </h1>
                    <p className="text-gray-400 text-lg">
                        We're working hard to bring you a collection of beautiful, customizable templates to help you get started quickly.
                    </p>
                </motion.div>
            </div>
        </div>
    )
}
